import React from 'react';
import AppsDownload from '../AppsDownload';
import StandardQRCode from '../../assets/img/DownloadAppQRCode.svg';
import styles from './AppPromo.module.css';

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {string=} props.QRCode
 * @param {boolean=} props.isFooter
 */
export default function AppPromo({
  className = '',
  QRCode = StandardQRCode,
  isFooter = false,
}) {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      <h3 className={`${styles.header} ${isFooter ? styles.footerHeader : ''}`}>
        Download our app
      </h3>
      <p className={styles.subtitle}>
        Download today to easily reserve items at the Fridge and earn rewards on
        Fridge purchases.
      </p>
      <div className={styles.appLinksRow}>
        <img
          alt="QR Code for the Farmer's Fridge App"
          className={styles.qrCodeImg}
          src={QRCode}
        />
        <AppsDownload whiteIcons className={styles.downloadAppContainer} />
      </div>
    </div>
  );
}
